module.exports = __webpack_public_path__ + "static/media/phone_3.1b36921b.png";